var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GSihImage',{staticClass:"flex items-center justify-center w-full h-full",attrs:{"loading":"lazy","src":"https://cdn.gogoout.com/web/icon-map.png","alt":"Google Map Icon","width":40}})}
var staticRenderFns = []

export { render, staticRenderFns }